import { UIChartArea } from '../area/ui-chart-area';
import { Component } from '../../../shared-components/decorators/component.decorator';
import styles from './ui-chart-areaspline.css';

/**
 * @class
 * @memberof ChartsComponents
 * @element ui-chart-areaspline
 * @augments {UIChartArea}
 * @alias UIChartAreaSpline
 * @classdesc Represents a class for <code>ui-chart-areaspline</code> element.
 * Draws areaspline type chart.
 * @slot {@type "ui-series"}
 * @example
 * <ui-chart-areaspline preset="interactive">
 *   <ui-series data="[10, 25, 50, 33, 43, 98]"></ui-series>
 * </ui-chart-areaspline>
 */
@Component({ tag: 'ui-chart-areaspline', styles })
export class UIChartAreaSpline extends UIChartArea {
    override get type(): string {
        return 'areaspline';
    }
}
